import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=19886c3c"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19886c3c')) {
      api.createRecord('19886c3c', component.options)
    } else {
      api.reload('19886c3c', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=19886c3c", function () {
      api.rerender('19886c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/Index.vue"
export default component.exports